export default __webpack_public_path__ + "static/media/2.762648b2.webp";